import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Grid, IconButton, Tooltip, Divider } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IBillingInformation } from '../../../shared/types/types';

interface BillingDialogProps {
  open: boolean;
  onClose: () => void;
  billingInfo: IBillingInformation;
}

const BillingDialog: React.FC<BillingDialogProps> = ({ open, onClose, billingInfo }) => {

  const handleCopyCode = () => {
    navigator.clipboard.writeText(billingInfo.code);
    alert('Código copiado para a área de transferência!');
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <DialogTitle>Detalhes do Pagamento</DialogTitle>
      </Grid>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6">Informações do Cliente</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Nome:</strong> {billingInfo.name_client}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>CPF/CNPJ:</strong> {billingInfo.cpfOrCnpj}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider style={{ margin: '20px ' }} /> {/* Linha divisória */}
          </Grid>

          <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant="h6">Informações do Pagamento</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Tipo de Cobrança:</strong> {billingInfo.type_billing}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Tipo de Cliente:</strong> {billingInfo.type_customer}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Valor:</strong> R$ {billingInfo.currency}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Data de Expiração:</strong> {billingInfo.expiration_date}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Status:</strong> {billingInfo.stats}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography><strong>Widepay ID:</strong> {billingInfo.widepay_id}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider style={{ margin: '20px ' }} /> {/* Linha divisória */}
          </Grid>
          <Grid item xs={12}>
            <Typography><strong>Código:</strong></Typography>
            <Grid container alignItems="center">
              <Grid item xs={10}>
                <Typography>{billingInfo.code}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Tooltip title="Copiar código">
                  <IconButton onClick={handleCopyCode}>
                    <ContentCopyIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography>
              <strong>QR Code:</strong>
            </Typography>
            <img
              src={`${billingInfo.qrCodeJson.imagem}`}
              alt="QR Code"
              style={{ width: '100%', maxWidth: '300px', marginTop: 10 }}
            />
          </Grid>

        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default BillingDialog;
